import { Icon } from '@iconify/react'
import styles from './RaspadinhaColorPickerField.module.css'

type RaspadinhaColorPickerFieldProps = {
  id: string
  label: string
  hint: string
  value: string
  fallbackColor: string
  onChange: (value: string) => void
}

export function RaspadinhaColorPickerField({
  id,
  label,
  hint,
  value,
  fallbackColor,
  onChange,
}: RaspadinhaColorPickerFieldProps) {
  const resolvedColor = value || fallbackColor

  const handleCopy = () => {
    void navigator.clipboard.writeText(resolvedColor)
  }

  return (
    <div className={styles.colorField}>
      <div className={styles.colorFieldHeader}>
        <label htmlFor={id} className={styles.colorLabel}>
          {label}
        </label>
        <span className={styles.colorHint}>{hint}</span>
      </div>
      <div className={styles.colorControl}>
        <div className={styles.colorSwatch} style={{ backgroundColor: resolvedColor }}>
          <input
            id={id}
            type="color"
            className={styles.colorInput}
            value={resolvedColor}
            onChange={(event) => onChange(event.target.value)}
            aria-label={label}
          />
        </div>
        <span className={styles.colorHex}>{resolvedColor}</span>
        <button
          type="button"
          className={styles.copyButton}
          onClick={handleCopy}
          title="Copiar código da cor"
          aria-label={`Copiar código da cor ${label.toLowerCase()}`}
        >
          <Icon icon="mdi:content-copy" />
        </button>
      </div>
    </div>
  )
}
